import pt_BR from './pt_BR';

const en_US: typeof pt_BR = {
  Yup: {
    cellphone_required: 'Cellphone is required',
    confirm_password_incorrect: 'The passwords do not match',
    confirm_password_required: 'Confirm password is required',
    cpf_required: 'Cpf is required',
    cpf_incomplete: 'Complete your CPF',
    email_required: 'E-mail is required',
    email_type: 'The field must be of type email',
    name_required: 'Name is required',
    password_required: 'Password is required',

    professional_record_required: 'Professional Record is required',
    birth_date_required: 'Birth date is required',
    address_zip_code_required: 'CEP is required',
    address_zip_code_incomplete: 'CEP incomplete',
    address_street_required: 'Street is required',
    address_number_required: 'Number is required',
    // address_complement_required: '',
    address_city_required: 'City is required',
    address_state_required: 'State is required',
    address_country_required: 'Country is required',
    holder_name_required: 'Required owner name',
    card_expiration_required: 'Mandatory expiration date',
    card_number_required: 'Required card number',
    card_cvv_required: 'Mandatory security code',
    registry_code_required: "Mandatory holder's CPF",
  },
  Toast: {
    error: 'There was an error please try again.',
    success: 'Successful registration',
    cep_not_found: 'Zip code not found, please enter address manually.',
  },
  Home: {
    button_signin: 'LOGIN',
    button_signup: 'SIGN UP',
    slogan: 'Training intelligence in the palm of your hand.',
    modal: {
      title: 'You are:',
      professor: 'Professor',
      professor_tooltip:
        'Profile with limited registration of up to 300 students',
      gym: 'Gym',
      gym_tooltip: 'Profile with limited registration of up to 1000 students',
      student: 'Student',
      student_tooltip:
        'Profile with limited registration of up to 300 students',
    },
  },
  Student: {},
  Professional: {
    SignIn: {
      title: 'Sign Up',
      subtitle: 'TRAINER',
      cpf_placeholder: 'CPF',
      cpf_cnpj_placeholder: 'CPF/CNPJ',
      password_placeholder: 'Password',
      remember_me: 'Remember me',
      forget_password: 'I forgot my password',
      button_login: 'LOG IN',
      sign_up_account: "Don't have an account ",
      sign_up_now: 'Register now',
      im_student: "I'm student",
      slogan_your_business: 'Your business',
      slogan_your_hand: 'in the palm of your hand.',
    },
    SignUp: {
      title: 'Sign Up',
      subtitle: 'TRAINER',
      name_placeholder: 'Name',
      cpf_placeholder: 'CPF',
      email_placeholder: 'E-mail',
      password_placeholder: 'Password',
      confirm_password_placeholder: 'Confirm password',
      cellphone_placeholder: 'Phone',
      conditions: 'By continuing, you agree with our ',
      terms_of_use: 'Termos de Uso',
      and: ' and ',
      policy_privacy: 'Privacy policy.',
      continue: 'CONTINUAR',
      sign_in_account: 'Already have an account? ',
      sign_in_login: 'Between here.',
      slogan_your_business: 'Your business',
      slogan_your_hand: 'in the palm of your hand.',
    },
    SignUpComplete: {
      gender_male: 'Male',
      gender_female: 'Female',
      gender_others: 'Others',

      title: 'Complete your registration',
      billing_information_title: 'Payment',
      name_placeholder: 'Name',
      cpf_placeholder: 'CPF',
      professional_record_placeholder: 'Professional Record',
      birth_date_placeholder: 'Birth Date',
      gender_placeholder: 'Gender',
      address_zip_code_placeholder: 'CEP',
      address_street_placeholder: 'Street',
      address_number_placeholder: 'Number',
      address_complement_placeholder: 'Complement',
      address_neighborhood_placeholder: 'Neighborhood',
      address_city_placeholder: 'City',
      address_state_placeholder: 'State',
      address_country_placeholder: 'Country',
      button_continue: 'CONTINUE',
      payment_continue: 'SUBSCRIBE TO PLAN',
      plan_information_title: 'Selected plan: ',
      plan_information: 'Registration system up to',
      plan_information_total_students: '250 students',
      holder_name: 'Name written on the card',
      card_expiration: 'Validity',
      card_number: 'Card number',
      card_cvv: 'CVV',
      registry_code: "Holder's CPF",
    },
  },

  Gym: {
    SignUp: {
      title: 'Sign Up',
      subtitle: 'GYM',
      company_name_placeholder: 'Name',
      cnpj_placeholder: 'CNPJ',
      email_placeholder: 'E-mail',
      password_placeholder: 'Password',
      confirm_password_placeholder: 'Confirm password',
      cellphone_placeholder: 'Phone',
      conditions: 'By continuing, you agree with our ',
      terms_of_use: 'Termos de Uso',
      and: ' and ',
      policy_privacy: 'Privacy policy.',
      continue: 'CONTINUAR',
      sign_in_account: 'Already have an account? ',
      sign_in_login: 'Between here.',
      slogan_your_business: 'Your business',
      slogan_your_hand: 'in the palm of your hand.',
    },
  },
};

export default en_US;
